<template>
  <div class="about">
    <h1>A Site for Event to Better the World!</h1>
  </div>
</template>
